import service from '@/utils/request'
import { IFileRead } from './nlp-api-type'
import { _c } from '@/utils'

import axios, { CancelToken } from 'axios'

const CancelToken = axios.CancelToken
function wrapRequestWithCancel <T extends (...params: any[]) => any>(fn: T): ReturnType<T> {
  let source = CancelToken.source()

  return function (...params: any[]) {
    source.cancel()
    source = CancelToken.source()
    return fn(source.token, ...params)
  } as  ReturnType<T>
}

export function getGraphApi (params: IFileRead.GraphReqParams, cancelToken: CancelToken) {
  return service.post(_c('/api/analysis/graph', false), params, {
    timeout: 0,
    cancelToken,
  })
}

// 重新获取主题词
export function getKeyWordApi (params: IFileRead.ThemeWordReqParams, cancelToken: CancelToken) {
  return service.post(_c('/api/analysis/keyword', false), params, {
    timeout: 0,
    cancelToken
  })
}

// 重新获取摘要
export function getAbstractApi (params: IFileRead.SummaryReqParams, cancelToken: CancelToken) {
  return service.post<null | string>(_c('/api/analysis/summary', false), params, {
    timeout: 0,
    cancelToken
  })
}
